export default "__VITE_ASSET__9c0198c0__"